import React, { Component } from 'react'
import {
  Title, Field, Label, Control, Input, Button, Notification, Delete, Help, Icon
} from 'bloomer'

import {gql} from 'apollo-boost'
import {Query, Mutation} from 'react-apollo'
import { Link } from 'react-router-dom'

const GET_ME = gql`
  query {
    me {
      id, firstName, lastName, email
    }
  }
`

const UPDATE_PROFILE = gql`
  mutation ($firstName: String!, $lastName: String!, $email: String!) {
    updateProfile (firstName: $firstName, lastName: $lastName, email: $email) {
      user { id, firstName, lastName, email }
    }
  }
`

class ProfileForm extends Component {
  state = {
    firstName: {
      value: this.props.user.firstName,
      error: ''
    },
    lastName: {
      value: this.props.user.lastName,
      error: ''
    },
    email: {
      value: this.props.user.email,
      error: ''
    },
    feedback: null
  }

  validateNotEmpty = (key, message) => {
    const { value } = this.state[key]

    if (value.trim() === '') {
      this.setState(() => ({
        [key]: {
          ...this.state[key],
          error: message
        }
      }))
      return false
    }

    this.setState(() => ({
      [key]: {
        ...this.state[key],
        error: ''
      }
    }))
    return true
  }

  validate = () => {
    const fields = [
      ['firstName', 'Informe seu nome'],
      ['lastName', 'Informe seu sobrenome'],
      ['email', 'Informe seu email']
    ]

    const cleanFields = fields.filter((args) => {
      return this.validateNotEmpty(...args)
    })

    return cleanFields.length === fields.length
  }

  clearFeedback = () => {
    this.setState(() => ({
      feedback: null
    }))
  }

  handleChange = (key) => (evt) => {
    const value = evt.target.value
    this.setState(() => ({
      [key]: {
        ...this.state[key],
        value
      }
    }))
  }

  handleSubmit = async (mutate, evt) => {
    evt.preventDefault()

    if (!this.validate()) {
      return
    }

    try {
      await mutate()
      this.setState(() => ({
        feedback: {
          type: 'success',
          message: 'Alterações salvas.'
        }
      }))
    } catch (e) {
      console.error(e)
      this.setState(() => ({
        feedback: {
          type: 'danger',
          message: 'Não foi possível se comunicar com o servidor.'
        }
      }))
    }

  }

  render() {
    const { user } = this.props
    const { firstName, lastName, email, feedback } = this.state

    return (

      <Mutation mutation={UPDATE_PROFILE} variables={{firstName: firstName.value, lastName: lastName.value, email: email.value}}>
      {(mutate, {loading}) => (
        <div>
          <Title isSize={3}>Perfil</Title>

          {feedback && <Notification isColor={feedback.type}><Delete onClick={this.clearFeedback}/> {feedback.message}</Notification>}

          <form onSubmit={this.handleSubmit.bind(this, mutate)} style={{marginBottom: '1rem'}}>
            <Field>
              <Label>Nome</Label>
              <Control>
                <Input
                  type="text"
                  placeholder={user.firstName}
                  value={firstName.value}
                  isColor={firstName.error ? 'danger' : ''}
                  onChange={this.handleChange('firstName').bind(this)}
                />
                {firstName.error && <Help isColor="danger">{firstName.error}</Help>}
              </Control>
            </Field>

            <Field>
              <Label>Sobrenome</Label>
              <Control>
                <Input
                  type="text"
                  placeholder={user.lastName}
                  value={lastName.value}
                  isColor={lastName.error ? 'danger' : ''}
                  onChange={this.handleChange('lastName').bind(this)}
                />
                {lastName.error && <Help isColor="danger">{lastName.error}</Help>}
              </Control>
            </Field>

            <Field>
              <Label>Email</Label>
              <Control>
                <Input
                  type="email"
                  placeholder={user.email}
                  value={email.value}
                  isColor={email.error ? 'danger' : ''}
                  onChange={this.handleChange('email').bind(this)}
                />
                {email.error && <Help isColor="danger">{email.error}</Help>}
              </Control>
            </Field>

            <Button type="submit" isColor="primary" isLoading={loading}>Atualizar perfil</Button>
          </form>

          <p>
            <Icon icon="info-circle"/>Procurando onde alterar sua senha? Você pode alterar em <Link to="/settings/account">Conta</Link>.
          </p>
        </div>
      )}
      </Mutation>
    )
  }
}

export default (props) => (
  <Query query={GET_ME}>
   {({data, loading, error}) => {
     if (error) {
      return <Notification isColor="danger">Ops... Você ainda está com internet?</Notification>
     }

     if (loading) {
      return <Notification>Carregando...</Notification>
     }

     return <ProfileForm user={data.me} {...props} />
   }}
  </Query>
)



// WEBPACK FOOTER //
// ./src/pages/SettingsPage/Profile.js